import React, {
  ReactNode,
} from 'react';
import { Dropdown } from 'react-bootstrap';
import { BsThreeDots } from 'react-icons/bs';

type Action = {
  label: ReactNode
  onClick: () => void
};

type DropdownActionsProps = {
  actions: Action[]
};

function DropdownActions( {
  actions,
}: DropdownActionsProps ) {
  return (
    <Dropdown className="table-dropdown" drop="down-centered">
      <Dropdown.Toggle variant="link" className="p-0">
        <BsThreeDots />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {actions.map( ( item, index ) => (
          <Dropdown.Item
            className="px-3 py-0 text--md text-primary"
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            onClick={item.onClick}
          >
            {item.label}
          </Dropdown.Item>
        ) )}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default DropdownActions;
